import * as React from 'react'

// import html2canvas from 'html2canvas'
import { DialogContent, IconButton, Tooltip } from '@mui/material'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

import CloseIcon from '@mui/icons-material/Close'
import { Card, CardContent, Dialog, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'
import { useRouter } from 'next/router'
import {
  getQCData,
  ISamplesQcData,
  PlotUrls
} from '@/@core/services/app.service'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

interface Props {
  analysisInfo: any
  plotUrls: string[]
}

const QualityControlFq2 = React.forwardRef((props: Props, ref) => {
  const { t } = useTranslation()
  const router = useRouter()

  const { id } = router.query
  const [fastqc, setFastqc] = React.useState<any>({
    metricsData: null,
    pctData: null,
    metricsReports: [],
    scatterUrl: 'string'
  })

  const [url, setUrl] = React.useState('')
  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    if (props.plotUrls.length > 0) {
      setFastqc({
        ...fastqc,
        metricsReports: props.plotUrls
      })
    }
  }, [props.plotUrls])

  const switchTitle = (number: number) => {
    switch (number) {
      case 0:
        return t(
          'The normal content of GC on the sequence is 35-65%. If the content of GC in the DNA sequence is too high, it is prone to form secondary structures, and the error rate of amplification will increase accordingly, resulting in incorrect sequence information obtained.'
        )
      case 1:
        return t(
          'By taking the sequencing cycle as a unit, a distribution graph of the base quality values of all Reads sequenced in parallel for a single sample can be made. This allows for viewing the sequencing quality of each sequencing cycle and the overall sequencing quality of the single sample.'
        )
      case 2:
        return t(
          'Based on the number of bases with different sequencing quality values, a distribution graph of the overall base quality can be drawn. For second-generation sequencing, generally, the proportion of bases with a quality value of Q20 should be > 95% (the worst case >= 90%), and the proportion of bases with a quality value of Q30 should be > 85% (the worst case >= 80%).'
        )
      case 3:
        return t(
          'Visualize and observe whether there is a periodic pattern in the insertion length to determine if it has a regular pattern.'
        )

      default:
        break
    }
  }

  React.useImperativeHandle(ref, () => {
    return {}
  })

  return (
    <Box id="print" overflow="auto" mt={5}>
      <Grid container height={'100%'} spacing={5}>
        {fastqc.metricsReports && Array.isArray(fastqc.metricsReports)
          ? fastqc.metricsReports.map((item: string, index: number) => {
              return (
                <Grid item xs={6} md={3} key={index}>
                  <Card
                    sx={{ width: '100%', height: '100%', cursor: 'pointer' }}
                    onClick={() => {
                      setUrl(item)

                      setOpen(true)
                    }}
                  >
                    <CardContent
                      sx={{
                        width: '100%',
                        height: '100%',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <Tooltip title={switchTitle(index)} placement="top">
                        <img
                          style={{ width: '100%', height: '100%' }}
                          src={item}
                          alt=""
                        />
                      </Tooltip>
                    </CardContent>
                  </Card>
                </Grid>
              )
            })
          : ''}
      </Grid>

      <BootstrapDialog
        onClose={() => {
          setUrl('')

          setOpen(false)
        }}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: 1200
          }
        }}
      >
        <IconButton
          aria-label="close"
          onClick={() => {
            setUrl('')

            setOpen(false)
          }}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box sx={{ minHeight: 300, minWidth: 1100 }}>
            <img style={{ width: '100%', height: '100%' }} src={url} alt="" />
          </Box>
        </DialogContent>
      </BootstrapDialog>
    </Box>
  )
})
export default QualityControlFq2
